import { fetchIdentityUser } from '@devhacker/shared/features/auth/api';
import { fetchProfileUser } from '@devhacker/shared/features/profile/api';
import { withProfileRetry } from '@devhacker/shared/features/profile/useProfileFallback';
import { mergeIdentityAndProfile } from '@devhacker/shared/features/user/mergeIdentityAndProfile';
import { decodeJWT } from '@devhacker/shared/features/auth/utils/jwt';
import { getAccessToken } from '@devhacker/shared/features/auth/utils/token';
import type { User } from '@devhacker/shared/features/user/types/user';

export async function fetchMergedUser(subId: string): Promise<User> {
  const accessToken = getAccessToken();

  const [identityResp, profileResp] = await Promise.allSettled([
    fetchIdentityUser(subId),
    withProfileRetry(() => fetchProfileUser(subId)),
  ]);

  return mergeIdentityAndProfile({
    integerId: subId,
    identity: identityResp.status === 'fulfilled' ? identityResp.value : null,
    profile: profileResp.status === 'fulfilled' ? profileResp.value : null,
    bannedAt: accessToken ? (decodeJWT(accessToken)?.banned_at ?? null) : null,
  });
}
